import { Injectable } from '@angular/core';
// import { HttpClientService } from 'src/app/http-client';
import { map } from 'rxjs/operators';
import { HttpClientService } from 'src/app/core/http/http-client';

@Injectable({
  providedIn: 'root'
})
export class SelfAssessmentService {

  constructor(private http: HttpClientService) { }

  checkIsAlreadySubmitted(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`selfassessment/is-already-submitted`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }

  getAssessment(id) {
    return this.http.get<{ data: any, result: number, msg: string }>(`selfassessment/exercise/${id}`).pipe(map(res => res.data));
  }

  saveAssessment(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`selfassessment`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }
  evaluateAssessment(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`selfassessment/evaluate-result`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }
}
